import type { ContactUsFormModel } from '../models/contact-us.form-model';

export const mapContactUsFormToDto = (form: ContactUsFormModel) => form as never;
